export default __webpack_public_path__ + "static/media/apt.87ce702d.svg";